import { PreviewState } from '../../../@types/state-types'
import { RealEstatePreview } from '../../../@types/preview-types'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export const initialState: PreviewState = {
  previewModalIsOpen: false,
  previewData: undefined,
}

const previewSlice = createSlice({
  name: 'previewFeature',
  initialState,
  reducers: {
    showPreviewModal(state) {
      state.previewModalIsOpen = true
      state.previewData = undefined
    },
    hidePreviewModal(state) {
      state.previewModalIsOpen = false
      state.previewData = undefined
    },
    setPreviewData(state, action: PayloadAction<{ previewData: RealEstatePreview | undefined }>) {
      state.previewData = action.payload.previewData
    },
  },
})
export const { showPreviewModal, hidePreviewModal, setPreviewData } = previewSlice.actions
export default previewSlice.reducer
